<template>
  <b-card class="border-0">
    <h4><b-icon icon="receipt-cutoff"  class="mr-2"/><translate>Terms and conditions of payment</translate></h4>
    <p><b><em v-translate>When asking for login in our B2B, you agree to comply with the following obligations:</em></b></p>
    <ul>
      <li v-translate>Our B2B page is dedicated exclusively to our partner travel agencies;</li>
      <li v-translate>It is forbidden to log into our B2B page with another agency's login;</li>
      <li v-translate>The modification of the Password of the account will be made only by us, upon request;</li>
      <li v-translate>It is forbidden to use our B2B page for speculative purposes, generating false or fraudulent bookings;</li>
      <li v-translate>In case of fraudulent use we reserve the right to block the access from our B2B page.</li>
    </ul>
    <h4><b-icon icon="exclamation-triangle-fill"  class="mr-2"/><translate>Terms and conditions of payment</translate></h4>
    <ol>
      <li v-translate>Rooms are distributed to the clients only by the hotel´s reception, we cannot guarantee a specific room type,
          bed type or room view. The check in and check out will be made accordingly to the hotel´s policy and time-table.</li>
      <li v-translate>Some hotels request additional payment for the use of some facilities in the room (for example: mini bar/fridge/safe/TV
          etc). We recommend that a list of additional costs should be passed to the clients before making the final
          reservation.</li>
      <li v-translate>Some 4* and 5* hotels request as guarantee cash or a card from the clients, which is held until the moment of
          check out. These are asked in order to guarantee the payment if the hotels additional facilities are used
          (where is the case) and it does not imply with anything the tour-operator agency.
      </li>
      <li v-translate>Unforeseen events, such as wars, earthquakes, strikes, natural phenomena or weather conditions do not bind the
          agency to compensations.</li>
      <li v-translate>Flight companies have the right to change the flight schedules, thus, the agency is not the one responsible for
          any modifications.</li>
      <li v-translate>Any reservation conducted through our B2B page, will be considered final and we will initiate the necessary confirmation
          and billing procedures.</li>
      <li v-translate>All touristic services published on our page are subject to the availability and terms of our providers. Provider
          terms may include provisions for different payment procedures, cancellation policies, changes in bookings
          and refunds (if any).</li>
      <li v-translate>The cancellation or modification of a booking, will be made according to the Terms and Conditions of the specific
          provider and should be passed to us in written form.</li>
    </ol>
  </b-card>
</template>

<script>
export default {
  name: 'emailAddress'
}
</script>

<style lang="scss" scoped>
  .modal-body h4 {
    font-size: 1.3rem;
    color: #293e97;
    border-bottom: 1px solid #ddd;
  }
</style>
